const Calendar = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 5a2.5 2.5 0 0 0-2.5 2.5v10A2.5 2.5 0 0 0 7 20h10a2.5 2.5 0 0 0 2.5-2.5v-10A2.5 2.5 0 0 0 17 5h-1V3a.5.5 0 0 0-1 0v2H9V3a.5.5 0 0 0-1 0v2zM5.5 7.5A1.5 1.5 0 0 1 7 6h10a1.5 1.5 0 0 1 1.5 1.5v1h-13zm0 10A1.5 1.5 0 0 0 7 19h10a1.5 1.5 0 0 0 1.5-1.5v-8h-13z"
      clipRule="evenodd"
    />
  </>
)
export default Calendar
